// src/pages/Trash.jsx
import React from 'react';
import { Trash2, AlertCircle } from 'lucide-react';

export default function Trash() {
    return (
        <div className="flex flex-col items-center justify-center h-full">
            <Trash2 className="h-16 w-16 text-gray-400 mb-4" />
            <h2 className="text-xl font-semibold text-gray-700">Trash Folder Not Available</h2>
            <p className="text-gray-500 mt-2 text-center max-w-md">
                Your email server is using POP3 protocol which doesn't support trash folders.
            </p>
            <div className="mt-6 p-4 bg-yellow-50 rounded-lg max-w-md">
                <div className="flex items-start">
                    <AlertCircle className="h-5 w-5 text-yellow-600 mt-0.5 mr-2 flex-shrink-0" />
                    <div className="text-sm text-yellow-800">
                        <p className="font-semibold mb-1">Warning about POP3 deletion</p>
                        <p>When you delete emails using POP3, they are permanently removed from the server and cannot be recovered.</p>
                    </div>
                </div>
            </div>
        </div>
    );
}